var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { combineReducers } from 'redux';
import merge from 'deepmerge';
import { curry, pipe } from './utils/fp';

export var isFunction = function isFunction(arg) {
    return typeof arg === 'function';
};
export var isObject = function isObject(arg) {
    return arg !== null && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object';
};

export var isReducer = function isReducer(reducer) {
    return isFunction(reducer);
};
export var hasNestedReducer = function hasNestedReducer(reducer) {
    return Object.values(reducer).some(isReducer);
};
export var shouldCombineNextLevel = function shouldCombineNextLevel(reducer) {
    return (isReducer(reducer) || isObject(reducer)) && hasNestedReducer(reducer);
};

/**
 * Merge all reducers together
 *
 * @export
 * @param {Object} reducers
 * @returns {Object} Merged reducers
 */
export var mergeReducers = function mergeReducers(reducers) {
    return reducers.reduce(function (result, reducer) {
        return merge(result, reducer);
    }, {});
};

/**
 * Recursively nest reducers
 *
 * @export
 * @param {Object} asyncReducers
 * @returns Merged nested reducers
 */
export var nestAsyncReducers = pipe(getReducersAtLevel, function (reducers) {
    return reducers.filter(isObject);
}, mergeReducers);

/**
 *
 *
 * @export
 * @param {Object} asyncReducers
 * @returns Array of possible empty items and reducer objects
 */
export function getReducersAtLevel(asyncReducers) {
    return Object.entries(asyncReducers).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            reducer = _ref2[1];

        // Set the key to a combination of the next level
        // NOTE: This will replace any reducer already set to this key
        if (shouldCombineNextLevel(reducer)) {
            return _defineProperty({}, key, combineReducers(
            // Recursive call
            nestAsyncReducers(reducer)));

            // No nested levels, then return the reducer
        } else if (isReducer(reducer)) {
            return _defineProperty({}, key, reducer);
        }
    });
}

/**
 * Create a combined reducer
 *
 * @param {Object} [initialReducers={}]
 * @param {Object} [asyncReducers={}]
 * @returns combined reducer
 */
function _createReducer(initialReducers, asyncReducers) {
    return combineReducers(_extends({}, initialReducers, nestAsyncReducers(asyncReducers)));
}

export var createReducer = curry(_createReducer);

/**
 *  Setup createReducer with initial reducers
 *  Will return a new function that will take async reducers to be injected
 *
 * @export
 * @param {Object} initialReducers
 * @returns Function
 */
export default function setupCreateReducer(initialReducers) {
    return createReducer(initialReducers);
}